export interface ClubProgram {
  clubprogramID?: number;
  clubProgramTypeID?: number;
  clubID?: number;
  name?: string;
  description?: string;
  regstatus?: number;
  programstatus?: string;
  regstartdate?: string;
  regenddate?: string;
  dateadded?: string;
  addedby?: number;
  public?: boolean;
  redirectLink?: string;
  teamID?: number;
  allowParentToEditQuestion?: number;
}

export class SimpleClubProgram {
  amountCollected: number;
  amountOutStanding: number;
  clubId: number;
  clubProgramID: number;
  clubProgramTypeID: number;
  currentParticipants: number;
  programName: string;
  programStatus: number;
  regStatus: boolean;
  slug: string;

  constructor(data: any = {}) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    if (this.programName) {
      this.slug = this.programName.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, ' ').replace(/[\s-]+/g, '-');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/club/club-program.ts